import isVoidType from '../utils/isVoidType';

const makeIsVoid = (editor) => {
  const {isVoid} = editor;

  return (element) => (isVoidType(element.type) ? true : isVoid(element));
};

export default makeIsVoid;
